import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Approuter from "./routes/router";
import TelegramIcon from "./components/TelegramIcon";

function App() {
  return (
    <BrowserRouter>
      <Approuter />
      <TelegramIcon />
    </BrowserRouter>
  );
}

export default App;
